import { startCase } from 'lodash';

type TitleParams = {
    name?: string;
    country?: string;
    internalType?: string;
    type?: string;
};

const getItemFieldTemplateTitle = ({ name, country, internalType, type }: TitleParams) => {
    const trimmedName = name?.trim();
    if (trimmedName) return trimmedName;

    const countryLabel = country?.toUpperCase();
    const internalTypeLabel = startCase(internalType?.toLowerCase());
    return `${countryLabel} ${internalTypeLabel} ${type} Item Fields Template`;
};

export default getItemFieldTemplateTitle;
